import * as React from 'react';
import { withIntl } from '@grandvisionhq/state';
import CartCounter from '../CartCounter/CartCounter.js';
import { getCartTotalsTitle } from '../Util/get-cart-totals-title.js';

class CartButton extends (React.Component) {
    static getCartCount() {
        const fromStorage = window.localStorage.getItem('stored_cart');
        if (!fromStorage) {
            return 0;
        }
        const cart = JSON.parse(fromStorage);
        return cart && cart.cartId ? cart.cartCount : 0;
    }
    componentDidMount() {
        // Get and set count on load
        const count = CartButton.getCartCount();
        this.setState({
            count
        });
        // update cart count in current window and other windows
        window.addEventListener('cart.change', this.onStoredCartChange);
        window.addEventListener('storage', this.onStoredCartChange);
    }
    componentWillUnmount() {
        window.removeEventListener('storage', this.onStoredCartChange);
        window.removeEventListener('cart.change', this.onStoredCartChange);
    }
    render() {
        const { count  } = this.state;
        const { href , className , intl , label , tabIndex  } = this.props;
        const ariaLabel = count === 0 ? intl.getLabel('cart.emptyCart.title') : getCartTotalsTitle(count, intl, 'cart.minicart.totalsTitle.singular', 'cart.minicart.totalsTitle');
        return /*#__PURE__*/ React.createElement("a", {
            className: `cart-button ${className || ''}`,
            href: href,
            title: label,
            tabIndex: tabIndex,
            "aria-label": tabIndex === -1 ? '' : ariaLabel
        }, /*#__PURE__*/ React.createElement(CartCounter, {
            count: count
        }), label && /*#__PURE__*/ React.createElement("span", {
            className: "cart-button__label"
        }, label));
    }
    constructor(...args){
        super(...args);
        this.state = {
            count: 0
        };
        this.onStoredCartChange = ()=>{
            const count = CartButton.getCartCount();
            this.setState({
                count
            });
        };
    }
}
CartButton.defaultProps = {
    href: '/cart',
    tabIndex: undefined
};
var CartButton$1 = withIntl(CartButton);

export { CartButton$1 as default };
//# sourceMappingURL=CartButton.js.map
